// @ts-ignore
import { singularize } from '@polleverywhere/core/lib/util'
// @ts-ignore
import activityFactory from '@polleverywhere/graphql-models/lib/activityFactory'
import { UnknownActivityError } from './UnknownActivityError'
import { FetchActivityError } from './FetchActivityError'
import type { Model, Collection } from 'backbone'

export type ActivityModel = InstanceType<typeof Model> & { polls?: Collection<ActivityModel>, [index: string]: any }

interface ErrorWithStatus extends Error {
  status: number
}

function errorWithStatus (error: unknown): error is ErrorWithStatus {
  return error instanceof Error && 'status' in error
}

/**
 * Forces the specified activity model to act as a participant instance.
 * To ensure results generate the correct request data when being submitted.
 */
function makeParticipantInstance (model: ActivityModel) {
  model.unset('presenter_key')
  if (model.polls) {
    model.polls.forEach((poll) => {
      poll.unset('presenter_key')
    })
  }
}

export async function fetchActivity(type: string, participantKey: string) {
  type = singularize(type)
  const model: ActivityModel = await activityFactory({
    type,
    participant_key: participantKey
  }) as ActivityModel

  if (!model) {
    throw new UnknownActivityError(`Unknown activity for '${type}'`)
  }

  makeParticipantInstance(model);

  try {
    const include = type === 'survey' ? 'poll_instances' : null
    await model.fetch({
      data: {
        include,
        exclude: 'flash_options,visual_settings'
      }
    });
  } catch (xhrError) {
    const status = errorWithStatus(xhrError) ? xhrError.status : 0
    throw new FetchActivityError('Cannot fetch activity', `${type}:${participantKey}`, status)
  }

  return model
}
